/**
 * Whether feedback submission should be blocked. A star rating is always
 * required; a comment is required unless commentOptional is set. Shared by the
 * variant submit buttons (disabled state) and the central submitFeedback guard
 * so the rule stays in one place.
 */
export const isSubmitDisabled = (
  selectedRating: number,
  commentOptional: boolean | null | undefined,
  comment: string,
): boolean => selectedRating < 1 || (!commentOptional && !comment.length);
